import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { formatMoney } from '@/utils/formatting';
import { cart } from '@/theme/Cart';

@Component
export class DiscountDelivery extends ThemeComponent {
    @Prop dataThreshold!: string|number;
    @Ref({required:false}) deliveryThreshold!: HTMLElement;

    /**
     * Initialise.
     */
    init() {
        this.setEventListeners();
        this.updateDeliveryMessage();
    }

    /**
     * Set event listeners.
     * When cart updates, check if free delivery threshold is exceeded.
     */
    setEventListeners() {
        const threshold =  this.getCurrencyThreshold();
        document.addEventListener('cartChanged', (e: Event) => {
            this.classList.toggle('discount-delivery--qualified', (cart.totalPrice >= threshold));
            this.classList.add('discount-delivery--loaded');
        });
    }

    getCurrencyThreshold() {
        const threshold =  Number(this.dataThreshold);
        // @ts-expect-error: Accessing window Shopify object
        const rate = window.Shopify.currency.rate;
        return (threshold * 100) * rate;
    }

    /**
     * Update free delivery.
     * Converts thresh hold and total price to store currency first.
     */
    updateDeliveryMessage() {
        const currencyThreshold = this.getCurrencyThreshold();
        const thresholdSpan = this.querySelector('[data-ref="deliveryThreshold"]');
        if (!thresholdSpan) { return; }
        thresholdSpan.innerHTML = formatMoney(currencyThreshold) as string;
    }
}
